'use strict';

import location from '../app-data/location';

/**
 * window.performance wrappers
 */
export default {
  getNavigation() {
    return (window && window.performance) ? window.performance.navigation : {};
  },

  /**
   * get all loaded resources
   */
  getResources() {
    const emptyVal = [];
    try {
      return (window &&
        window.performance &&
        window.performance.getEntriesByType &&
        window.performance.getEntriesByType('resource')) || emptyVal;
    } catch (e) {
      return emptyVal;
    }
  },

  getTiming() {
    return (window && window.performance) ? window.performance.timing : {};
  },

  /**
   * Duration relative to navigation start (window.performance.timing.navigationStart)
   */
  now() {
    return (window && window.performance && window.performance.now) ? window.performance.now() : new Date().getTime();
  },

  /**
   * Create a performance timestamp
   */
  mark(name) {
    if (location.isFedopsDev()) {
      window &&
        window.performance &&
        window.performance.mark &&
        window.performance.mark(name);
    }
  },

  /**
   * Record a performance measurement
   */
  measure(name, startMark, endMark) {
    if (location.isFedopsDev()) {
      window &&
        window.performance &&
        window.performance.measure &&
        window.performance.measure(name, startMark, endMark);
    }
  }
};



// WEBPACK FOOTER //
// ./performance/performance.js